/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class WeatherTableApi extends runtime.BaseAPI {
    /**
     * Create Weather Table
     */
    async v2CreateWeatherTableRaw(requestParameters, initOverrides) {
        if (requestParameters['weatherTableCreate'] == null) {
            throw new runtime.RequiredError('weatherTableCreate', 'Required parameter "weatherTableCreate" was null or undefined when calling v2CreateWeatherTable().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/weather-table/`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['weatherTableCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Weather Table
     */
    async v2CreateWeatherTable(requestParameters, initOverrides) {
        const response = await this.v2CreateWeatherTableRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete Weather Table
     */
    async v2DeleteWeatherTableRaw(requestParameters, initOverrides) {
        if (requestParameters['weatherTableId'] == null) {
            throw new runtime.RequiredError('weatherTableId', 'Required parameter "weatherTableId" was null or undefined when calling v2DeleteWeatherTable().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/weather-table/{weather_table_id}`;
        urlPath = urlPath.replace(`{${"weather_table_id"}}`, encodeURIComponent(String(requestParameters['weatherTableId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete Weather Table
     */
    async v2DeleteWeatherTable(requestParameters, initOverrides) {
        await this.v2DeleteWeatherTableRaw(requestParameters, initOverrides);
    }
    /**
     * Read Table
     */
    async v2ReadWeatherTableRaw(requestParameters, initOverrides) {
        if (requestParameters['weatherTableId'] == null) {
            throw new runtime.RequiredError('weatherTableId', 'Required parameter "weatherTableId" was null or undefined when calling v2ReadWeatherTable().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/weather-table/{weather_table_id}`;
        urlPath = urlPath.replace(`{${"weather_table_id"}}`, encodeURIComponent(String(requestParameters['weatherTableId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Read Table
     */
    async v2ReadWeatherTable(requestParameters, initOverrides) {
        const response = await this.v2ReadWeatherTableRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
